import { render } from "./AddTagTemplateWizard.vue?vue&type=template&id=4f250eb5"
import script from "./AddTagTemplateWizard.vue?vue&type=script&lang=js"
export * from "./AddTagTemplateWizard.vue?vue&type=script&lang=js"

import exportComponent from "/Users/rosswilliams/aqfer-workspace/cx-portal2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__